import { PaneArea } from '../../../../types/shared'
import RotatedRectangleV1, { IRotatedRectangleV1Attrs } from '../../../canvas/rotated_rectangle/rotated_rectangle_v1'
import PaneModel from '../../../models/pane'

type Area = PaneArea
type Attrs = IRotatedRectangleV1Attrs
type PartialAttrs = Partial<Attrs>

class RotatedRectangleV1Creator extends RotatedRectangleV1<Attrs> {
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    const xAxisOffset = this.model.scale.x.width(30)
    const yAxisOffset = this.model.scale.y.height(30)
    this.attrs.x1 = startArea.x - xAxisOffset
    this.attrs.x2 = startArea.x + xAxisOffset
    this.attrs.y1 = startArea.y - yAxisOffset
    this.attrs.y2 = startArea.y + yAxisOffset
    this.attrs.cursorTargetX = startArea.x + xAxisOffset
    this.attrs.cursorTargetY = startArea.y

    setTimeout(() => {
      this.replaceMyself(RotatedRectangleV1.fromObject<RotatedRectangleV1>(this.attrs, this.model))
      toolsCallback()
    })

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }
}

export default RotatedRectangleV1Creator
